export const filterOption = (value: string, option: any) => {
  if (typeof option.children === 'string') {
    return option.children.toLowerCase().includes(value.toLowerCase());
  }

  return option.children[1].toLowerCase().includes(value.toLowerCase());
};
